module.exports = __webpack_public_path__ + "img/AL802-2.661617dc.jpg";